import React from "react";
import "./RoundLoader.css";

const SIZE_PX = {
  sm: 22,
  md: 40,
  lg: 56,
};

/**
 * Shared circular loader used across tool-prep previews, editor canvas, and overlays.
 */
const RoundLoader = ({
  size = "md",
  label = null,
  className = "",
  labelClassName = "",
}) => {
  const px = SIZE_PX[size] || SIZE_PX.md;
  return (
    <div
      className={`rb-round-loader rb-round-loader--${size}${
        className ? ` ${className}` : ""
      }`}
      role="status"
      aria-label={label || "Loading"}
      aria-live="polite"
    >
      <span
        className="rb-round-loader__orbit"
        style={{ width: px, height: px }}
        aria-hidden
      >
        <span className="rb-round-loader__track" />
        <span className="rb-round-loader__arc" />
        <span className="rb-round-loader__glow" />
      </span>
      {label ? (
        <span
          className={`rb-round-loader__label${
            labelClassName ? ` ${labelClassName}` : ""
          }`}
        >
          {label}
        </span>
      ) : null}
    </div>
  );
};

export default RoundLoader;
